import { Skeleton, Stack } from '@mui/material';

import Typography from '../../../components/Typography';
import { Root } from './styles';

export interface PollWidgetSkeletonProps {
  className?: string;
}

const PollWidgetSkeleton = ({ className }: PollWidgetSkeletonProps) => {
  return (
    <Root className={className}>
      <Stack direction="row" alignItems="center" p={1.25} gap={1}>
        <Skeleton variant="rounded" width={16} height={16} />
        <Typography variant="paragraphBold" noWrap>
          <Skeleton variant="text" width={400} />
        </Typography>
      </Stack>
      <Typography variant="paragraphBold" component="h6" textTransform="uppercase" px={1.25} py={0.5}>
        <Skeleton variant="text" width={200} />
      </Typography>
      <Typography variant="paragraphRegular" noWrap p={1.25}>
        <Skeleton variant="text" width="100%" />
      </Typography>
    </Root>
  );
};

export default PollWidgetSkeleton;
